import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import {
	MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_FRAGMENT,
	MARKET_STATE_EXPORT_REPORT_EXECUTION_FRAGMENT
} from '@app/model/market_state/_export/service/MarketStateExportGraphQLFragments';

export const FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_REPORT_EXECUTIONS_QUERY: GraphQL = {
	name: 'findCompanyHotelMarketStateExportReportExecutions',
	gql: gql`
		${MARKET_STATE_EXPORT_REPORT_EXECUTION_FRAGMENT}
		query findCompanyHotelMarketStateExportReportExecutions($companyHotelId: Long!) {
			findCompanyHotelMarketStateExportReportExecutions(companyHotelId: $companyHotelId) {
				...MarketStateExportReportExecutionFields
			}
		}
	`
};

export const FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_DELIVERY_SCHEDULES_QUERY: GraphQL = {
	name: 'findCompanyHotelMarketStateExportDeliverySchedules',
	gql: gql`
		${MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_FRAGMENT}
		query findCompanyHotelMarketStateExportDeliverySchedules($companyHotelId: Long!) {
			findCompanyHotelMarketStateExportDeliverySchedules(companyHotelId: $companyHotelId) {
				...MarketStateExportDeliveryScheduleFields
			}
		}
	`
};

export const FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_REPORT_EXECUTION_QUERY: GraphQL = {
	name: 'findCompanyHotelMarketStateExportReportExecution',
	gql: gql`
		${MARKET_STATE_EXPORT_REPORT_EXECUTION_FRAGMENT}
		query findCompanyHotelMarketStateExportReportExecution($companyHotelId: Long!, $reportExecutionId: Long!) {
			findCompanyHotelMarketStateExportReportExecution(companyHotelId: $companyHotelId, reportExecutionId: $reportExecutionId) {
				...MarketStateExportReportExecutionFields
			}
		}
	`
};

export const DELETE_MARKET_STATE_EXPORT_REPORT_EXECUTION_MUTATION = {
	name: 'deleteMarketStateExportReportExecution',
	gql: gql`
		mutation deleteMarketStateExportReportExecution($reportExecutionId: Long!) {
			deleteMarketStateExportReportExecution(reportExecutionId: $reportExecutionId) {
				success
				exception
			}
		}
	`
};

export const SAVE_MARKET_STATE_EXPORT_REPORT_MUTATION: GraphQL = {
	name: 'saveMarketStateExportReport',
	gql: gql`
		${MARKET_STATE_EXPORT_REPORT_EXECUTION_FRAGMENT}
		mutation saveMarketStateExportReport($input: MarketStateExportReportInput!) {
			saveMarketStateExportReport(input: $input) {
				...MarketStateExportReportExecutionFields
			}
		}
	`
};

export const SAVE_MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_MUTATION: GraphQL = {
	name: 'saveMarketStateExportDeliverySchedule',
	gql: gql`
		${MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_FRAGMENT}
		mutation saveMarketStateExportDeliverySchedule($input: MarketStateExportDeliveryScheduleInput!) {
			saveMarketStateExportDeliverySchedule(input: $input) {
				...MarketStateExportDeliveryScheduleFields
			}
		}
	`
};
